export default __webpack_public_path__ + "static/media/Time Management.213cbc06.svg";